var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SmallCard', {
    staticClass: "my-plans-widget",
    attrs: {
      "icon": "icn20_coupon_2"
    },
    scopedSlots: _vm._u([{
      key: "header-text",
      fn: function () {
        return [_c('div', {
          staticClass: "header-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.headerLabel))])]), _c('div', {
          staticClass: "header-text text-no-wrap"
        }, [_c('span', [_vm._v(_vm._s(_vm.headerText))])])];
      },
      proxy: true
    }, {
      key: "header-row-content",
      fn: function () {
        return [_c('v-select', {
          staticClass: "rounded-select pl-3 pr-3",
          attrs: {
            "dense": "",
            "items": _vm.months,
            "outlined": ""
          },
          model: {
            value: _vm.selectedMonth,
            callback: function ($$v) {
              _vm.selectedMonth = $$v;
            },
            expression: "selectedMonth"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "d-flex justify-space-between mt-7"
  }, [_c('v-col', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.plansCount)
    }
  })]), _c('div', {
    staticClass: "block-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.plansLabel))])])]), _c('v-col', {
    staticClass: "active-plans-block block"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.aPlansCount)
    }
  })]), _c('div', {
    staticClass: "block-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.aPlansLabel))])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }